/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type SpecialPriceGroupFragment = {
  __typename: "SpecialPriceGroup"
  id: string
  name: string
  parentPriceGroup?: string | null
  productType: string
}

export const SpecialPriceGroupFragmentDoc = gql`
  fragment SpecialPriceGroup on SpecialPriceGroup {
    id
    name
    parentPriceGroup
    productType
  }
`
